import {
  LBBadge,
  LBTooltip,
  LBTooltipTrigger,
  LBTooltipContent
} from '@linearb/buzz'
import { getClassificationStyle, getHealthReason } from './orgHealth'
import type { OrgHealthScore } from '../../types'

type HealthScoreBadgeProps = {
  // Nullable so both callers can pass the API value straight through: the detail
  // endpoint omits it, the list row carries null for an unscored org.
  health?: OrgHealthScore | null
  className?: string
}

const HealthScoreBadge = ({ health, className }: HealthScoreBadgeProps) => {
  if (!health?.health_classification) {
    return null
  }
  const reason = getHealthReason(health)

  return (
    <LBTooltip>
      <LBTooltipTrigger asChild>
        <LBBadge
          variant='outline'
          className={`text-xs ${getClassificationStyle(health.health_classification).badge} ${className ?? ''}`}
        >
          {health.health_classification} · {health.total_score}
        </LBBadge>
      </LBTooltipTrigger>
      <LBTooltipContent className='px-3 py-1.5'>
        {reason
          ? `${reason} — customer health, scored per Salesforce family`
          : 'Customer health, scored per Salesforce family'}
      </LBTooltipContent>
    </LBTooltip>
  )
}

export default HealthScoreBadge
